(() => {
  document.querySelectorAll('.flippd-mobile-toggle').forEach(button => {
    const nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    const setOpen = open => {
      nav.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    button.addEventListener('click', () => setOpen(nav.hidden));
    nav.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
    document.addEventListener('click', event => {
      if (!nav.hidden && !nav.contains(event.target) && !button.contains(event.target)) setOpen(false);
    });
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape') { setOpen(false); button.focus(); }
    });
    matchMedia('(min-width:1024px)').addEventListener('change', () => setOpen(false));
  });
})();
